import React, { useEffect, useState } from "react";
import {
	boxStyle,
	buttonContainer,
	ButtonStyle,
	buttonStyle,
	containerStyle,
	customTextFieldStyle,
	errorStyleText,
	imgContainer,
	imgStyle,
	paperStyle,
} from "./formStyle";
import { Box, Button, Container, Grid, Paper, Typography } from "@mui/material";
import CustomTextField from "./CustomTextField";
import GetDetails from "./GetDetails";
import Loader from "./Loader";
import { useNavigate, Link } from "react-router-dom";
import { createMemberAccount, login, memberLogin, resetPassword, signup, updateuserNotfToken } from "../backend/backendApis";
import HttpService from "../backend/requestApis";
import { headingBlue, maroon, mediumGrey, pureWhite, yellowish } from "../assets/colors";
import { useDispatch } from "react-redux";
import { showSnackBar } from "./CustomComponents/CustomComponentsSlice";
import {
	clearRecaptchaInstance,
	getUser,
	sendOtp,
	setUpRecaptcha,
	verifyOTP,
} from "../utils/commonFunctions";
import firebase from "firebase/app";
import "firebase/auth";
import { auth, getMessagingInstance } from "../utils/firebase";
import CustomDropDown from "./CustomDropDown";
import CustomPasswordTextField from "./CustomPasswordTextField";
import { commonErrorStyleText } from "../utils/commonCSS";

const ReportSignup = () => {
	const [contact, setContact] = useState("");
	const [countryCode, setCountryCode] = useState('+91')
	const [newPassword, setNewPassword] = useState("");
	const [newPasswordError, setNewPasswordError] = useState('')
	const [confirmPassword, setConfirmPassword] = useState("");
	const [confirmPasswordError, setConfirmPasswordError] = useState('')
	const [pwdNotMatchingError, setPwdNotMatchingError] = useState('')
	const [isVerified, setIsVerified] = useState(false);
	const [WORKerDetails, setWORKerDetails] = useState({});
	const [submitError, setSubmitError] = useState(null);
	const [isLoader, setisLoader] = useState(false);
	const [isInternalLoader, setIsInternalLoader] = useState(false);
	const [isOTPLoader, setIsOTPLoader] = useState(false);
	const [OTP, setOTP] = useState(null);
	const [isOTPSent, setIsOtpSent] = useState(false);
	const [isOTPError, setIsOTPError] = useState(true);
	const [OTPErrorMsg, setOTPErrorMsg] = useState("");
	const [isOTPExpired, setIsOTPExpired] = useState(false);
	const [confirmationResult, setConfirmationResult] = useState(null);
	const [isOTPVerified, setIsOTPVerified] = React.useState(false)
	const [password, setPassword] = React.useState('')
	const [passwordError, setPasswordError] = React.useState('')

	const navigate = useNavigate();
	const dispatch = useDispatch();

	// Forgot Password States
	const [isForgotPassword, setIsForgotPassword] = useState(false);
	const [forgotPasswordStep, setForgotPasswordStep] = useState('otp'); // 'otp' | 'reset'
	const [forgotPasswordOTP, setForgotPasswordOTP] = useState('');
	const [forgotPasswordOTPError, setForgotPasswordOTPError] = useState('');
	const [forgotConfirmationResult, setForgotConfirmationResult] = useState(null);
	const [forgotPasswordToken, setForgotPasswordToken] = useState(null);
	const [resetNewPassword, setResetNewPassword] = useState('');
	const [resetNewPasswordError, setResetNewPasswordError] = useState('');
	const [resetConfirmPassword, setResetConfirmPassword] = useState('');
	const [resetConfirmPasswordError, setResetConfirmPasswordError] = useState('');
	const [resetMismatchError, setResetMismatchError] = useState('');

	const handleCancelForgotPassword = () => {
		setIsForgotPassword(false);
		setForgotPasswordStep('otp');
		setForgotPasswordOTP('');
		setForgotPasswordOTPError('');
		setForgotConfirmationResult(null);
		setForgotPasswordToken(null);
		setResetNewPassword('');
		setResetNewPasswordError('');
		setResetConfirmPassword('');
		setResetConfirmPasswordError('');
		setResetMismatchError('');
	};

	const handleForgotPasswordClick = async () => {
		try {
			setIsOTPLoader(true);
			setForgotPasswordOTP('');
			setForgotPasswordOTPError('');
			setResetNewPassword('');
			setResetConfirmPassword('');
			setResetNewPasswordError('');
			setResetConfirmPasswordError('');
			setResetMismatchError('');
			setIsForgotPassword(true);
			setForgotPasswordStep('otp');

			const sendOTPResult = await sendOtp(contact, countryCode);
			setForgotConfirmationResult(sendOTPResult);
			setIsOTPLoader(false);
			dispatch(showSnackBar({
				message: 'OTP sent to your registered contact number.',
				severity: 'info'
			}));
		} catch (err) {
			setIsOTPLoader(false);
			console.log('Error sending OTP for forgot password:', err);
			if (err?.msg && err.msg === 'auth/too-many-requests') {
				setForgotPasswordOTPError('Too many attempts. Please try again later.');
			} else {
				setForgotPasswordOTPError('Failed to send OTP. Please try again.');
			}
		}
	};

	const handleResendForgotPasswordOTP = async () => {
		try {
			setIsOTPLoader(true);
			setForgotPasswordOTP('');
			setForgotPasswordOTPError('');
			const sendOTPResult = await sendOtp(contact, countryCode);
			setForgotConfirmationResult(sendOTPResult);
			setIsOTPLoader(false);
			dispatch(showSnackBar({
				message: 'OTP resent successfully.',
				severity: 'info'
			}));
		} catch (err) {
			setIsOTPLoader(false);
			console.log('Error resending OTP:', err);
			if (err?.msg && err.msg === 'auth/too-many-requests') {
				setForgotPasswordOTPError('Too many attempts. Please try again later.');
			} else {
				setForgotPasswordOTPError('Failed to resend OTP. Please try again.');
			}
		}
	};

	const handleVerifyForgotPasswordOTP = async () => {
		if (!forgotPasswordOTP || forgotPasswordOTP.trim().length === 0) {
			setForgotPasswordOTPError('Please enter the OTP');
			return;
		}
		if (!forgotConfirmationResult) {
			setForgotPasswordOTPError('Please request an OTP first.');
			return;
		}
		try {
			setForgotPasswordOTPError('');
			setIsOTPLoader(true);
			const token = await verifyOTP(forgotConfirmationResult, forgotPasswordOTP);
			let idToken = token;
			if (!idToken && auth.currentUser) {
				idToken = await auth.currentUser.getIdToken(true);
			}
			setForgotPasswordToken(idToken);
			setIsOTPLoader(false);
			setForgotPasswordStep('reset');
			dispatch(showSnackBar({
				message: 'OTP verified successfully. Please enter your new password.',
				severity: 'success'
			}));
		} catch (err) {
			setIsOTPLoader(false);
			console.log('Error verifying OTP for password reset:', err);
			if (err?.msg && err.msg === 'auth/invalid-verification-code') {
				setForgotPasswordOTPError('Wrong OTP entered.');
			} else if (err?.msg && err.msg === 'auth/code-expired') {
				setForgotPasswordOTPError('OTP expired. Please click Resend OTP.');
			} else {
				setForgotPasswordOTPError('Error in verifying OTP. Please try again.');
			}
		}
	};

	const handleResetPasswordSubmit = async () => {
		let isValid = true;
		if (!resetNewPassword) {
			setResetNewPasswordError('Password is required');
			isValid = false;
		} else if (resetNewPassword.length < 6) {
			setResetNewPasswordError('Password must be at least 6 characters');
			isValid = false;
		} else {
			setResetNewPasswordError('');
		}

		if (!resetConfirmPassword) {
			setResetConfirmPasswordError('Confirm password is required');
			isValid = false;
		} else {
			setResetConfirmPasswordError('');
		}

		if (resetNewPassword && resetConfirmPassword && resetNewPassword !== resetConfirmPassword) {
			setResetMismatchError('Passwords do not match');
			isValid = false;
		} else {
			setResetMismatchError('');
		}

		if (!isValid) return;

		try {
			setIsOTPLoader(true);
			let idToken = forgotPasswordToken;
			if (!idToken && auth.currentUser) {
				idToken = await auth.currentUser.getIdToken(true);
			}

			if (!idToken) {
				setIsOTPLoader(false);
				setResetMismatchError('Authentication token missing or expired. Please verify OTP again.');
				setForgotPasswordStep('otp');
				return;
			}

			let options = {
				url: resetPassword,
				method: 'POST',
				payload: {
					newPassword: resetNewPassword
				},
				headers: {
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${idToken}`
					}
				}
			};

			await HttpService(options);
			setIsOTPLoader(false);
			dispatch(showSnackBar({
				message: 'Password reset successfully! Please login with your new password.',
				severity: 'success'
			}));
			handleCancelForgotPassword();
		} catch (err) {
			setIsOTPLoader(false);
			console.log('Error resetting password: ', err);
			const errorMsg = err?.response?.data?.description || err?.response?.data?.message || 'Failed to reset password. Please try again.';
			setResetMismatchError(errorMsg);
			dispatch(showSnackBar({
				message: errorMsg,
				severity: 'error'
			}));
		}
	};

	const updateOTP = (otp) => {
		setOTP(otp);
	};

	function updatePassword(password){
		setPassword(password)
	}

	function handleLogin(){
		try{
			setIsOTPLoader(true)
			let isValid = true

			if(!password){
				isValid = false
				setPasswordError('Password is required')
			}else {
				setPasswordError('')
			}

			if(isValid){
				let options = {
					url: memberLogin,
					method: 'POST',
					payload: {
						contact: contact,
						password: password
					}
				}
				HttpService(options).then(async (data) => {
					// console.log("data: ", data)
					// localStorage.clear()
					await localStorage.setItem('token', data?.data?.data?.token)
					await localStorage.setItem('contact', data?.data?.data?.contact)
					await localStorage.setItem('prefix', data?.data?.data?.namePrefix)
					await localStorage.setItem('smp', data?.data?.data?.smp)
					await localStorage.setItem('WORKerType', data?.data?.data?.WORKerType)

					const messagingInstance = await getMessagingInstance()

					if( messagingInstance) {
						const permission = await Notification.requestPermission()
						if( permission === 'granted'){
						
							const token = await messagingInstance.getToken( {
								vapidKey: "BISsL8UNR6XnXKHahdr3wgslH_HEXsO0JYE_qB8ptLBmA4lLj81Hfck6WAzwFg3grjgAR8kk_JKIN15D7AuzL_c"
							})
							let options = {
								url: updateuserNotfToken,
								method: 'PUT',
								payload: {
									contact: data?.data?.data?.contact,
									token: token
								},
								headers: {
									Authorization: localStorage.getItem('token')  ? `Bearer ${localStorage.getItem('token')}` : null
								}
							}
							HttpService(options).then(() => {
								console.log("Token Updated Successfully.")
							}).catch(err => {
								console.log('Error in updating Notification Token: ', err)
							})
						}
					}
					setIsOTPLoader(false)
					navigate('/reportForm')
				}).catch(err => {
					setIsOTPLoader(false)
					if( err?.status === 409){
						console.log("Inside.....")
						setPasswordError(() => 'Invalid Password')
					} else {
						console.log("Error in Login ", err)
						setPasswordError('Error in Login. Please Contact Support.')
					}
					
				})
			} else {
				setIsOTPLoader(false)
			}
		}catch(err){
			console.log("Error in Login: ", err)
			setIsOTPLoader(false)
			setPasswordError('Error in Login. Please Contact Support.')
		}
	}

	function handleNewPasswordChange(password) {
		setNewPassword(password);
	}

	function handleConfirmPasswordChange(password) {
		setConfirmPassword(password);
	}

	async function handleSignUp() {
		try {
			setIsOTPLoader(true)
			let isValid = true

			if( !newPassword){
				setNewPasswordError('Password is required')
				isValid = false
			} else {
				setNewPasswordError('')
			}

			if( !confirmPassword){
				isValid = false
				setConfirmPasswordError('Confirm Password is required.')
			} else {
				setConfirmPasswordError('')
			}

			if ( newPassword != confirmPassword){
				isValid = false
				setPwdNotMatchingError('Unmatched Passwords')
			} else {
				setPwdNotMatchingError('')
			}

			if(isValid){
				let user = await getUser()
				let options = {
					url: createMemberAccount,
					method: "POST",
					payload: {
						password: newPassword,
						name: WORKerDetails.name,
						gender: WORKerDetails.gender,
						contact: WORKerDetails.contactNumber,
						designation: 'member'
					},
					headers: {headers: {
						Authorization: user._lat ? `Bearer ${user._lat}` : null
					}}
				};
				HttpService(options).then(() => {
					console.log('Member Account created successfully.')
					let options = {
						url: memberLogin,
						method: 'POST',
						payload: {
							contact: contact,
							password: newPassword
						}
					}
					HttpService(options).then(async (data) => {
						let options = {
							url: memberLogin,
							method: 'POST',
							payload: {
								contact: contact,
								password: newPassword
							}
						}
						HttpService(options).then(async (data) => {
							setIsOTPLoader(false)
							// localStorage.clear()
							await localStorage.setItem('token', data?.data?.data?.token)
							await localStorage.setItem('contact', data?.data?.data?.contact)
							await localStorage.setItem('prefix', data?.data?.data?.namePrefix)
							await localStorage.setItem('smp', data?.data?.data?.smp)
							navigate('/reportForm')
						}).catch(err => {
							setIsOTPLoader(false)
							if( err?.status === 409){
								setPwdNotMatchingError(() => 'Invalid Password')
							} else {
								setPwdNotMatchingError('Error in Login. Please Contact Support.')
							}
						})
					}).catch(err => {
						setIsOTPLoader(false)
						if( err?.status === 409){
							setPwdNotMatchingError(() => 'Invalid Password')
						} else {
							setPwdNotMatchingError('Error in Login. Please Contact Support.')
						}
						
					})
				}).catch(err => {
					setIsOTPLoader(false)
					if(err?.status === 403){
						localStorage.clear()
						navigate('/signUp')
					  } else
						if( err?.status === 409){
							setPwdNotMatchingError('Account already exists.')
						} else {
							setPwdNotMatchingError('There is some error. Please contact support.')
						}
				} )				
			}else{
				setIsOTPLoader(false)
			}
	
			
		} catch (err) {
			setIsOTPLoader(false)
			console.log("Error in handling signup.", err);
			// isLoader(false);
		}
	}

	React.useEffect(() => {
		setIsOtpSent(false);
		setIsOTPError(false);
		setIsOTPVerified(false)
		setNewPasswordError(null)
		setConfirmPasswordError(null)
		setPwdNotMatchingError(null)
		setPassword(null)
		setPasswordError(null)
		setNewPassword(null)
		setConfirmPassword(null)
		handleCancelForgotPassword();
	}, [WORKerDetails]);

	React.useEffect(() => {
		async function getToken(){
		setisLoader(true);
		let token = await localStorage.getItem("token");
		setisLoader(false);
		if (token) {
			navigate("/reportForm");
		}
	}
	getToken()
	}, []);

	return (
		<>
			{isLoader ? (
				<Loader />
			) : (
				<div style={containerStyle}>
					<div id="recaptcha-container"></div>
					<div style={imgContainer}>
						<img
							src={require("../assets/images/WORK_logo.png")}
							alt="Logo"
							style={imgStyle}
						></img>
					</div>
					<Paper style={paperStyle}>
						<Container
							style={{
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								gap: "0.5rem",
								alignItems: "center",
								textAlign: "center",
								padding: "0.4rem 0.4rem 0rem 0.4rem",
							}}
						>
							<Typography
								style={{
									padding: "0.2rem",
									fontSize: "1.2rem",
									fontWeight: "bold",
									color: yellowish,
								}}
								// onClick={handleSignUp}
							>
								Sign Up/ Login
							</Typography>
							{isInternalLoader && <Loader></Loader>}
							<GetDetails
								contact={contact}
								setContact={setContact}
								countryCode={countryCode}
								setCountryCode={setCountryCode}
								setIsVerified={setIsVerified}
								WORKerDetails={WORKerDetails}
								setWORKerDetails={setWORKerDetails}
								setSubmitError={setSubmitError}
								setisLoader={setIsInternalLoader}
								isLoader={isInternalLoader}
							/>

							{Object.keys(WORKerDetails).length > 0 && (
								<>
									{isOTPLoader && <Loader></Loader>}
									{!isOTPSent && !isOTPError && (
										<>
											{WORKerDetails.isRegistered ? (
												!isForgotPassword ? (
													<Box style={{display: 'flex', alignItems: "center", flexDirection: 'column', padding: '0rem 0rem 1rem 0rem'}}>
														<CustomPasswordTextField placeHolder='Enter Your Password' value={password} setFunc={updatePassword}></CustomPasswordTextField>
														<Typography style={{...errorStyleText, fontSize: '0.8rem'}}>{passwordError}</Typography>
														<Button variant='outlined' sx={{ backgroundColor: headingBlue, width: "6rem", border: "1px solid #D9D9D9", marginTop: '0.6rem', fontWeight: "500", fontSize: "0.9rem", color: pureWhite, padding: '0.1rem 0.3rem 0.1rem 0.3rem'}}
															onClick={handleLogin}
														>
															Login
														</Button>
														<Typography
															sx={{
																color: headingBlue,
																fontSize: '0.85rem',
																cursor: 'pointer',
																textDecoration: 'underline',
																fontWeight: '500',
																marginTop: '0.8rem',
																'&:hover': { color: maroon }
															}}
															onClick={handleForgotPasswordClick}
														>
															Forgot Password?
														</Typography>
													</Box>
												) : (
													forgotPasswordStep === 'otp' ? (
														<Box style={{ display: 'flex', alignItems: "center", flexDirection: 'column', padding: '0.5rem 0rem 1rem 0rem', width: '100%', maxWidth: '20rem' }}>
															<Typography style={{ padding: "0.2rem", color: yellowish, fontSize: '1rem', fontWeight: 'bold' }}>
																Forgot Password
															</Typography>
															<Typography style={{ fontSize: '0.82rem', color: headingBlue, marginBottom: '0.5rem' }}>
																{forgotConfirmationResult ? `OTP sent to ${countryCode} ${contact}` : 'Sending OTP to your number...'}
															</Typography>

															{forgotConfirmationResult ? (
																<>
																	<CustomTextField
																		placeHolder="Enter the OTP"
																		value={forgotPasswordOTP}
																		setFunc={(val) => setForgotPasswordOTP(val)}
																	/>
																	{forgotPasswordOTPError && (
																		<Typography style={{ ...commonErrorStyleText, fontSize: '0.8rem', marginTop: '0.3rem' }}>
																			{forgotPasswordOTPError}
																		</Typography>
																	)}
																	<Button
																		variant='outlined'
																		sx={{ backgroundColor: headingBlue, width: "7rem", border: "1px solid #D9D9D9", marginTop: '0.8rem', fontWeight: "500", fontSize: "0.9rem", color: pureWhite, padding: '0.1rem 0.3rem' }}
																		onClick={handleVerifyForgotPasswordOTP}
																	>
																		Verify OTP
																	</Button>
																</>
															) : (
																<>
																	{forgotPasswordOTPError && (
																		<Typography style={{ ...commonErrorStyleText, fontSize: '0.8rem', marginTop: '0.3rem' }}>
																			{forgotPasswordOTPError}
																		</Typography>
																	)}
																	<Button
																		variant='outlined'
																		sx={{ backgroundColor: headingBlue, width: "7rem", border: "1px solid #D9D9D9", marginTop: '0.8rem', fontWeight: "500", fontSize: "0.9rem", color: pureWhite, padding: '0.1rem 0.3rem' }}
																		onClick={handleForgotPasswordClick}
																	>
																		Send OTP
																	</Button>
																</>
															)}

															<Box style={{ display: 'flex', gap: '1rem', marginTop: '0.8rem', alignItems: 'center' }}>
																{forgotConfirmationResult && (
																	<>
																		<Typography
																			sx={{
																				color: headingBlue,
																				fontSize: '0.82rem',
																				cursor: 'pointer',
																				textDecoration: 'underline',
																				'&:hover': { color: maroon }
																			}}
																			onClick={handleResendForgotPasswordOTP}
																		>
																			Resend OTP
																		</Typography>
																		<Typography sx={{ color: '#aaa', fontSize: '0.8rem' }}>|</Typography>
																	</>
																)}
																<Typography
																	sx={{
																		color: headingBlue,
																		fontSize: '0.82rem',
																		cursor: 'pointer',
																		textDecoration: 'underline',
																		'&:hover': { color: maroon }
																	}}
																	onClick={handleCancelForgotPassword}
																>
																	Back to Login
																</Typography>
															</Box>
														</Box>
													) : (
														<Box style={{ display: 'flex', alignItems: "center", flexDirection: 'column', padding: '0.5rem 0rem 1rem 0rem', width: '100%', maxWidth: '20rem' }}>
															<Typography style={{ padding: "0.2rem", color: yellowish, fontSize: '1rem', fontWeight: 'bold' }}>
																Reset Password
															</Typography>
															<Typography style={{ fontSize: '0.82rem', color: headingBlue, marginBottom: '0.6rem' }}>
																Please enter your new password
															</Typography>

															<CustomPasswordTextField
																placeHolder='Enter New Password'
																value={resetNewPassword}
																setFunc={(val) => setResetNewPassword(val)}
															/>
															{resetNewPasswordError && (
																<Typography style={{ ...commonErrorStyleText, fontSize: '0.8rem' }}>{resetNewPasswordError}</Typography>
															)}

															<CustomPasswordTextField
																placeHolder='Confirm New Password'
																value={resetConfirmPassword}
																setFunc={(val) => setResetConfirmPassword(val)}
															/>
															{resetConfirmPasswordError && (
																<Typography style={{ ...commonErrorStyleText, fontSize: '0.8rem' }}>{resetConfirmPasswordError}</Typography>
															)}

															{resetMismatchError && (
																<Typography style={{ ...commonErrorStyleText, fontSize: '0.85rem' }}>{resetMismatchError}</Typography>
															)}

															<Button
																variant='outlined'
																sx={{ backgroundColor: headingBlue, minWidth: "8rem", border: "1px solid #D9D9D9", marginTop: '0.8rem', fontWeight: "500", fontSize: "0.9rem", color: pureWhite, padding: '0.1rem 0.5rem' }}
																onClick={handleResetPasswordSubmit}
															>
																Reset Password
															</Button>

															<Typography
																sx={{
																	color: headingBlue,
																	fontSize: '0.82rem',
																	cursor: 'pointer',
																	textDecoration: 'underline',
																	marginTop: '0.8rem',
																	'&:hover': { color: maroon }
																}}
																onClick={handleCancelForgotPassword}
															>
																Back to Login
															</Typography>
														</Box>
													)
												)
											) :
											<>
											{isOTPExpired && (
												<Typography
													style={{
														...errorStyleText,
														fontSize: "0.9rem",
														fontWeight: 550,
													}}
												>
													OTP expired. Try again
												</Typography>
											)}
											<button
												style={{
													...buttonStyle,
													backgroundColor: isOTPSent ? mediumGrey : headingBlue,
												}}
												disabled={isOTPSent}
												onClick={async () => {
													try {
														setIsOTPLoader(true);
														let sendOTPResult = await sendOtp(contact, countryCode);
														setConfirmationResult(sendOTPResult);
														setIsOTPLoader(false);
														setIsOtpSent(true);
													} catch (err) {
														setIsOTPLoader(false);
														setIsOTPError(true);
														if (err.msg && err.msg === "auth/too-many-requests")
															setOTPErrorMsg(
																"Too many attempts, try again later after sometime."
															);
														else
															setOTPErrorMsg("Please refresh and try again.");
													}
												}}
											>
												GET OTP
											</button>
											</>
											}
											{/* <div id="recaptcha-container"></div> */}
										</>
									)}

									{isOTPSent && !isOTPVerified && (
										<>
											<Box style={boxStyle}>
												<Typography
													style={{ padding: "0.3rem", color: yellowish }}
												>
													OTP sent Successfully.
												</Typography>
												<CustomTextField
													placeHolder="Enter the OTP"
													value={OTP}
													setFunc={updateOTP}
												></CustomTextField>
												<Box style={{padding: '0rem'}}>
													<button
														style={buttonStyle}
														onClick={async () => {
															try {
																setOTPErrorMsg('')
																setIsOTPLoader(true);
																let token = await verifyOTP(
																	confirmationResult,
																	OTP
																);
																// await clearRecaptchaInstance()
																setIsOTPLoader(false);
																if (token) {
																	// setConfirmationResult(null)
																	await localStorage.setItem("fToken", token);
																	setIsOTPVerified(true)
																	// navigate("/reportForm");
																}
															} catch (err) {
																setIsOTPLoader(false);
																console.log("Error: ", err);
																if (
																	err?.msg &&
																	err?.msg === "auth/invalid-verification-code"
																) {
																	setIsOTPError(true);
																	setOTPErrorMsg("Wrong OTP");
																} else if (
																	err?.msg &&
																	err?.msg === "auth/code-expired"
																) {
																	setIsOtpSent(false);
																	setIsOTPError(false);
																	setIsOTPExpired(true);
																	setOTPErrorMsg("OTP expired.");
																} else {
																	console.log("error: ", err);
																	setIsOTPError(true);
																	setOTPErrorMsg(
																		"Error in verifying OTP. Please refresh and try again."
																	);
																}
															}
														}}
													>
														SUBMIT
													</button>
												</Box>
											</Box>
										</>
									)}
									{isOTPError && (
										<>
											<Box style={{padding: '0.5rem'}}>
												<Typography
													style={{ ...commonErrorStyleText, fontSize: "0.9rem" }}
												>
													{OTPErrorMsg}
												</Typography>
											</Box>
										</>
									)}

									{ isOTPVerified && 
										<>
											<Box style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '0.5rem'}}>
												<CustomPasswordTextField placeHolder='Enter Password' value= {newPassword} setFunc={handleNewPasswordChange}></CustomPasswordTextField>
												<Typography style={commonErrorStyleText}>{newPasswordError}</Typography>
												<CustomPasswordTextField placeHolder= 'Confirm Password' value={confirmPassword} setFunc={handleConfirmPasswordChange}></CustomPasswordTextField>
												<Typography style={commonErrorStyleText}>{confirmPasswordError}</Typography>
												<Typography style={{...commonErrorStyleText, fontSize: '0.9rem'}}>{pwdNotMatchingError}</Typography>
												<Button variant='outlined' sx={{ backgroundColor: headingBlue, width: "6rem", border: "1px solid #D9D9D9", marginTop: '0.6rem', fontWeight: "500", fontSize: "0.9rem", color: pureWhite, padding: '0.1rem 0.3rem 0.1rem 0.3rem'}}
													onClick={handleSignUp}
												>
													SignUp
												</Button>
											</Box>
											
										</>
									}
								</>

								// <div style={{ marginBottom: "0.5rem", marginTop: "0.5rem" }}>
								// 	<CustomTextField
								// 		setFunc={handleNewPasswordChange}
								// 		placeholder="Contact Number"
								// 		value={newPassword}
								// 		style={customTextFieldStyle}
								// 	></CustomTextField>
								// 	<CustomTextField
								// 		setFunc={handleConfirmPasswordChange}
								// 		placeholder="Contact Number"
								// 		value={confirmPassword}
								// 		style={customTextFieldStyle}
								// 	></CustomTextField>
								// 	<div style={buttonContainer}>
								// 		<button style={buttonStyle}>Sign Up</button>
								// 	</div>

								// 	<div style={buttonContainer}>
								// 		<button
								// 			style={{ border: "none", backgroundColor: "white" }}
								// 			onClick={handleLogin}
								// 		>
								// 			Login
								// 		</button>
								// 	</div>
								// </div>
							)}
							<Box style={{ marginTop: "1rem", display: "flex", justifyContent: "center" }}>
								<Link
									to="/privacy-policy"
									style={{
										color: headingBlue,
										fontSize: "0.85rem",
										textDecoration: "underline",
										fontWeight: "500",
									}}
								>
									Privacy Policy
								</Link>
							</Box>
						</Container>
					</Paper>
				</div>
			)}
		</>
	);
};

export default ReportSignup;
